import React from 'react'
import { Grid } from '@material-ui/core'


export const ClaimFinish = () => {

    return (<>
        <br />
        <br />
        <Grid container spacing={3} justify={'center'} >
            <Grid item sm={12} md={5} >
                <div className="bold blue text-promotion">Thank You For Submitting!</div>
                <br />
                <br />
                <div className="text-body black">Your claim has been received and is currently being</div>
                <br />
                <div className="text-body black">reviewed by our team.</div>
                <br />
                <div className="text-body black">A SkyWatch.AI representative will be in touch with you as soon as possible.</div>
            </Grid>
            <Grid item sm md>
                <img src={process.env.PUBLIC_URL + '/assets/claims/claim_finished.svg'} />
            </Grid>
        </Grid>
    </>)
}